import { useOutletContext } from 'react-router-dom'

import { SettingsEmployeeGroupFragment } from 'generated/resources/graphql'

import AssignModal from 'modules/legal_entities/components/EmployeeGroups/AssignModal'
import { useOnClose } from 'modules/legal_entities/hooks/useOnClose'

const AssignPage = () => {
  const { employeeGroup } = useOutletContext<{ employeeGroup: SettingsEmployeeGroupFragment }>()
  const onClose = useOnClose(employeeGroup.legalEntityId)

  return <AssignModal onClose={onClose} employeeGroup={employeeGroup} />
}

export default AssignPage
